<a (click)="signIn()">
  <img async src="https://static.zip.co/icons/icon-person.svg" /> Customer sign
  in
</a>
<a href="{{ merchantLogin }}">
  <img async src="https://static.zip.co/icons/icon-shop.svg" /> Merchant sign in
</a>
